import { render, staticRenderFns } from "./ResumeFee.vue?vue&type=template&id=6fd6b384&"
import script from "./ResumeFee.vue?vue&type=script&lang=js&"
export * from "./ResumeFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports